/* this file is transformed by vux-loader */
/* eslint-disable */
require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.match.js");

exports.install = function (Vue) {
  /**
  * @describe 计算时间相差天数 
  * @use this.DateDiff('2020--8-01','2020-10-30')
  * @result 
  */
  Vue.prototype.DateDiff = function (date1, date2) {
    // 把年月日时分秒字符串转成时间戳
    var d1 = Date.parse(new Date(date1));
    var d2 = Date.parse(new Date(date2)); // 根据时间差值，算出天数

    return (d1 - d2) / (1000 * 3600 * 24);
  }; // 限制输入两位小数


  Vue.prototype.LimitTwoDecimal = function (e) {
    e.target.value = e.target.value.match(/^\d*(\.?\d{0,1})/g)[0] || null;
  };
};